import React from "react";
import ExclusivelyCraftedImage from "./ExclusivelyCraftedImage";
import ExclusivelyCraftedText from "./ExclusivelyCraftedText";

const ExclusivelyCrafted = ({ hideTopLines = false, ...rest }) => {
  return (
    <section className="section topless" {...rest}>
      <div className="container">
        {/* <ExclusivelyCraftedImage /> */}
        <ExclusivelyCraftedText hideTopLines={hideTopLines} />
      </div>
    </section>
  );
};

export default ExclusivelyCrafted;
